export default function () {

    function buildReactiveHead (lesson, error) {
        watch(lesson, () => {buildHead(lesson.value, error.value);}, {immediate: true});
    }

    function buildHead(lesson, error) {
        if (lesson === null && !error) return useSeo().buildHeadLoading();
        if (!lesson) return useSeo().buildHeadNotFound();

        let title = lesson.lesson_title;

        if (lesson.course_title) {
            title = `${title} | ${lesson.course_title}`;
        }

        return useSeo().buildHead({
            type: 'video',
            image: lesson.lesson_image_url || null,
            video: lesson.lesson_video_content_url || null,
            title: `${title} | Andy Guitar`,
            description: lesson.lesson_excerpt || lesson.lesson_excerpt_fallback || 'View details of this lesson on the Andy Guitar website.',
            structuredData: useSchemaVideo().build(lesson),
            index: true,
        });
    }

    return {buildReactiveHead};
};
